/* eslint-disable no-template-curly-in-string */
// @flow

export default {
  NoRecordsFound: 'Keine Aufzeichnungen gefunden.',
  DocumentIndex: 'Dokumentenindex',
  SubmissionIndex: 'Einreichungsindex',
  Search: 'Suche',
  Searching: 'Suche...',
  Filter: 'Filtern',
  FullTextSearch_SentenceCase: 'Volltextsuche',
  BulkDownload_SentenceCase: 'Sammeldownload',
  ExportToExcel: 'Nach Excel exportieren',
  ExpandAll_SentenceCase: 'Alle erweitern',
  CollapseAll_SentenceCase: 'Alle reduzieren',
  BulkDownloadName_SentenceCase: 'Paketname',
  SelectAll_SentenceCase: 'Alle auswählen',
  AskQuestion: 'Stellen Sie eine Frage',
  Move: 'Ziehen um',
  Edit: 'Bearbeiten',
  OpenInOfficeOnline: 'In Microsoft Office für das Web öffnen',
  EditInOfficeOnline: 'Bearbeiten in Microsoft Office für das Web',
  Security: 'Sicherheit',
  Enable: 'Aktivieren',
  Disable: 'Deaktivieren',
  Delete: 'Löschen',
  History: 'Geschichte',
  History_LowerCase: 'Geschichte',
  ManageDocuments: 'Dokumente verwalten',
  SelectDocumentsToRedact: 'Wählen Sie die zu redigierenden Dokumente aus',
  Submissions: 'Einreichungen',
  TenderSubmissions: 'Ausschreibungen',
  Add: 'Hinzufügen',
  Folder: 'Ordner',
  Document: 'Dokument',
  Document_LowerCase: 'Dokument',
  Documents_LowerCase: 'Dokumente',
  Folder_LowerCase: 'Ordner',
  Folders_LowerCase: 'Ordner',
  Renumber: 'Neu nummerieren',
  BulkUpload_SentenceCase: 'Massenupload',
  BulkDownloadOverDownloadLimit:
    'Sie haben die Begrenzung der Downloadgröße von 100 GB erreicht. Bitte entfernen Sie Dateien aus der Auswahl, um fortzufahren.',
  Name_: 'Name:',
  Number_: 'Nummer:',
  Retry: 'Erneut versuchen',
  FolderNotDeletedAccess:
    'FEHLER: Der Ordner konnte nicht gelöscht werden, da er mindestens ein Dokument und/oder Unterordner enthält, auf die Sie keinen Zugriff haben.',
  FolderNotDeleted: 'FEHLER: Der Ordner konnte nicht gelöscht werden.',
  DocumentNotDeleted: 'FEHLER: Das Dokument konnte nicht gelöscht werden.',
  FolderNotUpdated: 'FEHLER: Der Ordner konnte nicht aktualisiert werden.',
  DocumentNotUpdated: 'FEHLER: Das Dokument konnte nicht aktualisiert werden.',
  ParentFolderDisabled: 'Übergeordneter Ordner ist deaktiviert',
  EnableDocument:
    'Dieser Ordner enthält 1 Dokument. Möchten Sie diesen Ordner wirklich aktivieren?',
  EnableDocuments: '\u003cb\u003eAktivieren\u003c/b\u003e dokumente',
  EnableFolder:
    'Dieser Ordner enthält 1 Ordner. Möchten Sie diesen Ordner wirklich aktivieren?',
  EnableFolderDocument:
    'Dieser Ordner enthält 1 Ordner und 1 Dokument. Möchten Sie diesen Ordner wirklich aktivieren?',
  EnableFolderDocuments:
    'Dieser Ordner enthält 1 Ordner und ${NumberOfDocuments}. Möchten Sie diesen Ordner wirklich aktivieren?',
  EnableFolders:
    'Dieser Ordner enthält ${NumberOfFolders}. Möchten Sie diesen Ordner wirklich aktivieren?',
  EnableFoldersDocument:
    'Dieser Ordner enthält die Ordner ${NumberOfFolders} und 1 Dokument. Möchten Sie diesen Ordner wirklich aktivieren?',
  EnableFoldersDocuments:
    'Dieser Ordner enthält die Ordner ${NumberOfFolders} und Dokumente mit der Rolle ${NumberOfDocuments}. Möchten Sie diesen Ordner wirklich aktivieren?',
  BulkEnableFolders: 'Die Ordner ${NumberOfFolders} werden aktiviert.',
  BulkEnableFoldersWithImplicitFolders:
    'Um diese Elemente zu aktivieren, müssen alle übergeordnete Ordner aktiviert werden. Die Ordner ${NumberOfFolders} werden aktiviert.',
  BulkEnableOneFolder: '1 Ordner wird aktiviert.',
  BulkEnableOneFolderAndDocuments:
    '1 Ordner und ${NumberOfDocuments} werden aktiviert.',
  BulkEnableOneFolderAndDocumentsWithImplicitFolders:
    'Um diese Elemente zu aktivieren, müssen alle übergeordnete Ordner aktiviert werden. 1 Ordner und ${NumberOfDocuments} werden aktiviert.',
  BulkEnableOneFolderAndOneDocument:
    '1 Ordner und 1 Dokument werden aktiviert.',
  BulkEnableOneFolderAndOneDocumentWithImplicitFolders:
    'Um diese Elemente zu aktivieren, müssen alle übergeordnete Ordner aktiviert werden. 1 Ordner und 1 Dokument werden aktiviert.',
  BulkEnableDocuments: 'Dollar-Dokumente werden aktiviert.',
  BulkEnableOneDocument: '1 Dokument wird aktiviert.',
  BulkEnableFoldersAndOneDocument:
    '${NumberOfFolders}-Ordner und 1 Dokument werden aktiviert.',
  BulkEnableFoldersAndOneDocumentWithImplicitFolders:
    'Um diese Elemente zu aktivieren, müssen alle übergeordnete Ordner aktiviert werden. ${NumberOfFolders}-Ordner und 1 Dokument werden aktiviert.',
  BulkEnableFoldersAndDocuments:
    '${NumberOfFolders}-Ordner und $Office-Dokumente werden aktiviert.',
  BulkEnableFoldersAndDocumentsWithImplicitFolders:
    'Um diese Elemente zu aktivieren, müssen alle übergeordnete Ordner aktiviert werden. ${NumberOfFolders}-Ordner und $Office-Dokumente werden aktiviert.',
  BulkEnableDocumentsErrorMessage:
    'FEHLER: Die Dokumente von ${NumberOfDocuments} konnten nicht aktiviert werden.',
  BulkEnableFoldersErrorMessage:
    'FEHLER: Die Ordner ${NumberOfFolders} konnten nicht aktiviert werden.',
  BulkEnableFoldersDocumentsErrorMessage:
    'FEHLER: Die Ordner ${NumberOfFolders} und die Dokument(e) ${NumberOfDocuments) konnten nicht aktiviert werden.',
  DisableDocument:
    'Dieser Ordner enthält 1 Dokument. Möchten Sie diesen Ordner wirklich deaktivieren?',
  DisableDocuments: '\u003cb\u003eDeaktivieren\u003c/b\u003e Dokumente',
  DisableFolder:
    'Dieser Ordner enthält 1 Ordner. Möchten Sie diesen Ordner wirklich deaktivieren?',
  DisableFolderDocument:
    'Dieser Ordner enthält 1 Ordner und 1 Dokument. Möchten Sie diesen Ordner wirklich deaktivieren?',
  DisableFolderDocuments:
    'Dieser Ordner enthält 1 Ordner und ${NumberOfDocuments}. Möchten Sie diesen Ordner wirklich deaktivieren?',
  DisableFolders:
    'Dieser Ordner enthält ${NumberOfFolders}-Ordner. Möchten Sie diesen Ordner wirklich deaktivieren?',
  DisableFoldersDocument:
    'Dieser Ordner enthält die Ordner ${NumberOfFolders} und 1 Dokument. Möchten Sie diesen Ordner wirklich deaktivieren?',
  DisableFoldersDocuments:
    'Dieser Ordner enthält die Ordner ${NumberOfFolders} und Dokumente von ${NumberOfDocuments}. Möchten Sie diesen Ordner wirklich deaktivieren?',
  DisableFolderConfirm:
    'Wenn der Ordner „${FolderName}“ andere Ordner enthält, werden diese ebenfalls deaktiviert.',
  BulkDisableFolders: '${NumberOfFolders}-Ordner werden deaktiviert.',
  BulkDisableOneFolder: '1 Ordner wird deaktiviert.',
  BulkDisableOneFolderAndDocuments:
    '1 Ordner und ${NumberOfDocuments} werden deaktiviert.',
  BulkDisableOneFolderAndOneDocument:
    '1 Ordner und 1 Dokument werden deaktiviert.',
  BulkDisableDocuments: '${NumberOfDocuments}-Dokumente werden deaktiviert.',
  BulkDisableOneDocument: '1 Dokument wird deaktiviert.',
  BulkDisableFoldersAndOneDocument:
    '${NumberOfFolders}-Ordner und 1 Dokument werden deaktiviert.',
  BulkDisableFoldersAndDocuments:
    '${NumberOfFolders}-Ordner und ${NumberOfDocuments}-Dokumente werden deaktiviert.',
  BulkDisableDocumentsErrorMessage:
    'FEHLER: Die Dokumente von ${NumberOfDocuments} konnten nicht deaktiviert werden.',
  BulkDisableFoldersErrorMessage:
    'FEHLER: Die Ordner ${NumberOfFolders} konnten nicht deaktiviert werden.',
  BulkDisableFoldersDocumentsErrorMessage:
    'FEHLER: Die Ordner ${NumberOfFolders} und die Dokument(e) ${NumberOfDocuments}) konnten nicht deaktiviert werden.',
  DeleteFileConfirmation: '„${FileName}“ wird umgehend gelöscht.',
  DeleteFolderConfirmation: '„${FolderName}“ wird umgehend gelöscht.',
  BulkDeleteFolders: '${NumberOfFolders}-Ordner werden gelöscht.',
  BulkDeleteOneFolder: '1 Ordner wird gelöscht.',
  BulkDeleteOneFolderAndDocuments:
    '1 Ordner und ${NumberOfDocuments} werden gelöscht.',
  BulkDeleteOneFolderAndOneDocument: '1 Ordner und 1 Dokument werden gelöscht.',
  BulkDeleteDocuments: '${NumberOfDocuments}-Dokumente werden gelöscht.',
  BulkDeleteOneDocument: '1 Dokument wird gelöscht.',
  BulkDeleteFoldersAndOneDocument:
    '${NumberOfFolders}-Ordner und 1 Dokument werden gelöscht.',
  BulkDeleteFoldersAndDocuments:
    'Die Ordner „${NumberOfFolders}“ und „${NumberOfDocuments}“ werden gelöscht.',
  BulkDeleteDocumentsErrorMessage:
    'FEHLER: ${NumberOfDocuments} konnten nicht gelöscht werden.',
  BulkDeleteFoldersErrorMessage:
    'FEHLER: Die Ordner ${NumberOfFolders} konnten nicht gelöscht werden.',
  BulkDeleteFoldersDocumentsErrorMessage:
    'FEHLER: Die Ordner ${NumberOfFolders} und die Dokument(e) ${NumberOfDocuments} konnten nicht gelöscht werden.',
  AddFolder: 'Ordner hinzufügen',
  AddDocument: 'Dokument hinzufügen',
  CopyLink_SentenceCase: 'Link kopieren',
  SendToKira_SentenceCase: 'An Kira senden',
  Actions: 'Aktionen',
  Download: 'Download',
  DownloadPart: 'Download-Teil ${number}',
  BulkDownloadIsNotSwitchedOnContactAdmin_Gen2:
    'Der Massendownload ist nicht aktiviert. Für weitere Informationen wenden Sie sich an den Administrator',
  Disabled: 'Deaktiviert',
  FileTypeUnknown: 'Datei',
  FileTypeAcrobat: 'Acrobat-PDF',
  FileTypeArchive: 'Archiv',
  FileTypeAudio: 'Audiodatei',
  FileTypeCode: 'Code',
  FileTypeContact: 'Kontakt',
  FileTypeEmail: 'E-Mail',
  FileTypeExcel: 'Excel',
  FileTypeImage: 'Bild',
  FileTypeLayoutAndDesign: 'Designdokument',
  FileTypePowerpoint: 'PowerPoint',
  FileTypeText: 'Text',
  FileTypeVideo: 'Video',
  FileTypeVisio: 'Visio',
  FileTypeWord: 'Wort',
  SavingAllowed: 'Speichern erlaubt',
  SavingDenied: 'Speichern verweigert',
  PrintingAllowed: 'Drucken erlaubt',
  PrintingDenied: 'Drucken verweigert',
  FileExtensionEmpty: 'keine Erweiterung',
  OneBulkDownloadInProgress: '1 Sammeldownload in Bearbeitung - ${progress}%',
  NumberOfBulkDownloadInProgress:
    '${number}-Massendownloads in Bearbeitung - ${progress} %',
  Cancel: 'Stornieren',
  Expand: 'Erweitern',
  Collapse: 'Zusammenbruch',
  FolderEmpty: 'Ordner leer',
  UseChromeToBulkUpload:
    'Verwenden Sie Chrome, um Dokumente und Ordner massenweise hochzuladen.',
  RenumberCallToAction: 'Neu nummerieren',
  Archives: 'Archiv',
  BulkDownloadUnavailable:
    'Der Massendownload ist derzeit nicht möglich. Bitte versuchen Sie es später noch einmal',
  PreviewNotAvailable: 'Vorschau nicht verfügbar',
  DocumentIsTooLargeToPreview:
    'Dieses Dokument ist zu groß für eine Vorschau. Sie müssen das Dokument herunterladen, um es anzuzeigen.',
  DocumentIsTooLargeToPreviewWithoutDownload:
    'Dieses Dokument ist zu groß für eine Vorschau',
  FileCannotBePreviewed:
    'Diese Datei kann nicht in der Vorschau angezeigt werden.',
  OwnerHasSecuredThisDocument: 'Der Eigentümer hat dieses Dokument geschützt',
  ThisDocumentIsSecuredWithAdobeRightsManagement:
    'Dieses Dokument ist mit Adobe Rights Management geschützt. Sie benötigen Adobe Acrobat Reader und müssen online sein, um dieses Dokument anzuzeigen.',
  ThisDocumentIsSecuredWithMicrosoftRightsManagement:
    'Dieses Dokument ist mit Microsoft Rights Management geschützt. Sie benötigen Microsoft Office und müssen online sein, um dieses Dokument anzuzeigen.',
  SecuredPdfHelpLink:
    'Erfahren Sie mehr über \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePDF-Dokumente anzeigen.\u003c/a\u003e',
  SecuredPdfHelpLinkMac:
    'Erfahren Sie mehr über \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePDF-Dokumente anzeigen.\u003c/a\u003e',
  SecuredDocHelpLink:
    'Erfahren Sie mehr über \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eAnzeigen von Office-Dokumenten.\u003c/a\u003e',
  YourDownloadIsBeingPrepared: 'Ihr Download wird vorbereitet...',
  OwnerHasSecuredTheseDocuments: 'Der Eigentümer hat diese Dokumente gesichert',
  SecuredPdfAndDocHelpLink:
    'Erfahren Sie mehr über \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eviewing PDF documents\u003c/a\u003e or \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice documents.\u003c/a\u003e',
  SecuredPdfAndDocHelpLinkMac:
    'Erfahren Sie mehr über \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eviewing PDF documents\u003c/a\u003e or \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice documents.\u003c/a\u003e',
  DocumentsAreSecuredWithMicrosoftOrAdobeRightsManagement:
    'Diese Dokumente sind mit Adobe Rights Management oder Microsoft Rights Management geschützt. Sie benötigen Adobe Acrobat Reader oder Microsoft Office und müssen online sein, um diese Dokumente anzuzeigen.',
  UnableToDownloadThisFileTryAgain:
    'Diese Datei kann nicht heruntergeladen werden.',
  DownloadStarted: 'Download gestartet',
  Close: 'Schließen',
  GotIt: 'Verstanden',
  Preview: 'Vorschau',
  DontShowThisAgain: 'Nicht mehr anzeigen',
  BulkDownloadPrepareTitle: 'Ihr Download wird vorbereitet...',
  BulkDownloadPrepareAwareMessage:
    'Bitte beachten Sie, dass die Bearbeitung umso länger dauern kann, je größer der Download.',
  BulkDownloadPrepareMessage:
    'Es wird eine E-Mail an <strong>${email}</strong> gesendet, wenn Ihr Download bereit ist.',
  BulkDownloadLimitError:
    'Sie haben das Downloadlimit von ${limitedNumnerOfItems}-Dateien oder ${limitedFileSize} erreicht. Bitte entfernen Sie Dateien aus der Auswahl, um fortzufahren.',
  LinkCopiedToClipboard: 'Link in die Zwischenablage kopiert',
  RestoreDocuments: 'Dokumente wiederherstellen',
  RepairNumbering: 'Reparaturnummerierung',
  BulkUpdate: 'Massenupdate',
  GenerateFolders: 'Ordner erzeugen',
  NotificationsReport: 'Benachrichtigungsbericht',
  DownloadHelpInfo:
    'Wenn der Download nach einigen Sekunden nicht gestartet wurde, verwenden Sie bitte a',
  DirectLink: 'direkter Link',
  YourDocumentsAreDownloading: 'Ihre Dokumente werden heruntergeladen',
  DocumentRenamed: 'Das Dokument wurde umbenannt.',
  FolderRenamed: 'Ordner wurde umbenannt.',
  FolderRenamedRenumber:
    'Neu nummerieren, um den Ordnerinhalt zu aktualisieren',
  DocumentsNotificationList: 'Liste der DokumentBenachrichtigungen',
  UserDocumentNotificationSettings:
    'Einstellungen für Benutzerdokument-Benachrichtigungen',
  IntervalType: 'Intervalltyp',
  NumberOfUsers: 'Anzahl der Benutzer',
  NotificationList: 'Benachrichtigungsliste',
  ExportSelectedItemsToExcel: '[Number] nach Excel exportieren',
  ToEmail: 'An E-Mail',
  FromSentDateSydneyTime: 'Vom gesendeten Datum (Sydney-Zeit)',
  ToSentDateSydneyTime: 'Anzu senden am (Sydney-Zeit)',
  DocID: 'Dokumenten-ID',
  DocName: 'Dokumentenname',
  To: 'Zu',
  UserType: 'Benutzertyp',
  SentDateSydneyTime: 'Gesendet am (Sydney-Zeit)',
  Previous: 'Zurück',
  Next: 'Weiter',
  DisableFolderConfirmHeader: 'Sie sind dabei, einen Ordner zu deaktivieren',
  ThereAreNoAvailableFoldersAndDocumentsAtTheMoment:
    'Derzeit sind keine Dokumente oder Ordner verfügbar.',
  ThereAreNoDocumentsOrFoldersMatchingFilterCriteria:
    'Es gibt keine Dokumente oder Ordner, die den Filterkriterien entsprechen.',
  DeleteFolderConfirmHeader: 'Sie sind dabei, einen Ordner zu löschen',
  DeleteFileConfirmHeader: 'Sie sind dabei, eine Datei zu löschen',
  MoveItemDialogUseDestinationFolderSecurity:
    'Verwenden Sie Ordnersicherheitseinstellungen von ${destinationFolderName}',
  MoveItemDialogSecuritySettingsLabel: 'Sicherheitseinstellungen',
  MoveItemDialogUseCurrentFolderSecurity:
    'Verwenden Sie die aktuellen Sicherheitseinstellungen',
  MoveItemDialogNotifyCheckbox:
    'Personen benachrichtigen, wenn Zugriff gewährt wird',
  MoveItemNewLocation: 'Neuer Ort: ',
  DontHavePermissionToMoveFolder:
    'Sie haben keine Berechtigung, diesen Ordner zu verschieben.',
  DontHavePermissionToMoveFolders:
    'Sie haben keine Berechtigung, diese Ordner zu verschieben.',
  DontHavePermissionToMoveItemsMoveIntoFolder:
    'Sie haben keine Berechtigung, Elemente in diesen Ordner zu verschieben.',
  SecuredFileIsTooLargeToPreview:
    'Die Datei, die Sie in der Vorschau anzeigen möchten, ist zu groß. Sie können es stattdessen herunterladen.',
  SecuredFileIsTooLargeToPreviewWithoutDownload:
    'Die Datei, die Sie in der Vorschau anzeigen möchten, ist zu groß.',
  BeforeYouDownload: 'Vor dem Download',
  SecuredPreviewPdfHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eErfahren Sie mehr über das Anzeigen von PDF-Dokumenten.\u003c/a\u003e',
  SecuredPreviewPdfHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eErfahren Sie mehr über das Anzeigen von PDF-Dokumenten.\u003c/a\u003e',
  SecuredPreviewDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eWeitere Informationen zum Anzeigen von Office-Dokumenten.\u003c/a\u003e',
  StartYourDataRoomAndAddDocument:
    'Starten Sie Ihren Datenraum und fügen Sie Dokumente hinzu.',
  UploadDocuments: 'Dokumente hochladen',
  ExpiredDocumentAccess:
    'Ihr Zugriff auf dieses Dokument ist abgelaufen. Wenden Sie sich an den Datenraum-Administrator, um Zugriff zu erhalten.',
  MultipleDragDropInfo:
    'Wählen Sie die zu verschiebenden Dokumente und Ordner per Drag &amp; Drop aus',
  DemoMultipleDragDropTitle: 'Wie es funktioniert',
  Zipping: 'Reißverschluss',
  Processing: 'In Bearbeitung...',
  YourFilesAreReadyToDownload: 'Ihre Dateien stehen zum Download bereit',
  ThisBulkDownloadIsSplit:
    'Dieser Download ist zu groß und wir haben ihn in mehrere Teile aufgeteilt. Diese Links finden Sie auch in Ihrer E-Mail.',
  BulkDownloadEmptyFoldersNote: 'Leere Ordner werden nicht heruntergeladen.',
  NotifyPeopleWhenAccessIsGranted:
    'Personen benachrichtigen, wenn Zugriff gewährt wird',
  BulkEnableConfirmHeader: 'Ordner und Dokumente freischalten',
  BulkDisableConfirmHeader: 'Ordner und Dokumente deaktivieren',
  CopyDocumentsInProgress: 'Laden des Dokumentindex wird durchgeführt',
  SomeDocumentsAreSecuredLink:
    'Einige Dokumente sind durch den Administrator geschützt. Um sie zu öffnen, benötigen Sie:',
  EnableTruncation: 'Trunkierung aktivieren',
  OptimizeFilePathForWindows: 'Dateipfad für Windows optimieren',
  TruncationNoteForWindows:
    'Für Windows-Benutzer müssen Sie zum Extrahieren 7-Zip unter Windows 10 verwenden.',
  Restore: 'Wiederherstellen',
  Current: 'Aktuell',
  AddedBy: 'Hinzugefügt von',
  UpdatedBy: 'Aktualisiert von',
  RestoreThisVersion: 'Diese Version wiederherstellen',
  AdobeAcrobatReader: 'Adobe Acrobat Reader',
  MicrosoftOffice: 'Microsoft Office',
  InternetConnection: 'Internetverbindung',
  BulkDeleteConfirmHeader: 'Ordner und Dokumente löschen',
  Preparing: 'Vorbereiten...',
  SomeSavingDeniedFilesSelected:
    '$Office-Dokumente haben die Richtlinie „Speichern verweigert“ und werden nicht heruntergeladen.',
  RestoreDocumentSuccessMessage: '${title} wurde wiederhergestellt',
  RestoreVersionNumberButtonText: 'Version ${versionNumber} wiederherstellen',
  HistoryDialogNothingChangeMessage:
    'Diese Version ist die gleiche wie die aktuelle Version',
  HistoryDialogNoDocumentChangeMessage:
    'Der Dokumentinhalt wurde nicht geändert',
  HistoryDialogNoNameAndNumberChangeMessage:
    'Name und Nummer des Dokuments wurden nicht geändert',
  ResetViewAsToDownload: 'Zum Download den Filter „Anzeigen als“ zurücksetzen.',
  NoPermissionToDownloadTooltip:
    'Der Administrator hat den Massendownload für diesen Raum deaktiviert',
  Remove: 'Entfernen',
  Reset: 'Zurücksetzen',
  ResetNow: 'Jetzt zurücksetzen',
  ResetDialogTitle: 'Übermittlungsprozess zurücksetzen',
  ResetDialogContent:
    'Möchten Sie den Übermittlungsprozess wirklich zurücksetzen? Das Abschlussdatum und die Uhrzeit werden zurückgesetzt.',
  Confirm: 'Bestätigen',
  Region: 'Region',
  KiraSuccessfullyConnectedTitle: 'Erfolgreich mit Kira verbunden',
  KiraSuccessfullyConnectedFirstLine:
    'Sie können jetzt Dokumente zum Aufdecken an Kira senden',
  KiraSuccessfullyConnectedSecondLine:
    'relevante Informationen aus Verträgen und zugehörigen Dokumenten.',
  KiraProjectsLoading: 'Projekte werden geladen...',
  KiraSelectProject: 'Wählen Sie ein Projekt in Kira aus...',
  KiraSendDocument: 'Dokument an Kira senden',
  KiraConnect: 'Mit Kira verbinden',
  KiraCompanyUrl: 'Ihre Kira-Firmen-URL',
  KiraApiToken: 'Kira API-Token',
  KiraUnableToConnect:
    'Wir konnten keine Verbindung zu Kira herstellen. Bitte bestätigen Sie Ihre Region und Ihr Token und versuchen Sie es erneut.',
  KiraConfigError:
    'Beim Laden der Konfiguration ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  KiraProjectsLoadError:
    'Wir konnten Ihre Projekte nicht von Kira abrufen. Bitte versuchen Sie es erneut.',
  KiraSendDocumentError:
    'Beim Senden des Dokuments an Kira ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  KiraSendingDocument: 'Senden Sie „${documentName}“ an Kira',
  KiraDocumentSent: "'${documentName}' wurde an Kira gesendet",
  Redact: 'Redigieren',
  RedactDocuments: 'Dokumente redigieren',
  EditRedact: 'Redigierung bearbeiten',
  RedactionIsNotAvailable: 'Redigierung ist nicht verfügbar',
  RedactGetDocumentError:
    'Wir konnten dieses Dokument nicht erhalten. Bitte versuchen Sie es erneut',
  RedactBurnDocumentError:
    'Wir konnten dieses Dokument nicht redigieren. Bitte versuchen Sie es erneut',
  RedactFileTooLarge:
    'Dateien, die größer als ${fileSize} sind, werden derzeit nicht für die Redigierung unterstützt. Optimieren Sie die Dokumentgröße und versuchen Sie es erneut.',
  RedactSaveDialogTitle: 'Als neues redigiertes Dokument speichern',
  MultipleDocumentsErrorDescription:
    'Die markierten ${numberOfDocuments}-Dokumente konnten nicht verarbeitet werden. Sie können versuchen, das Dokument erneut hochzuladen.',
  SingleDocumentErrorDescription:
    '1 markiertes Dokument konnte nicht verarbeitet werden. Sie können versuchen, das Dokument erneut hochzuladen.',
  MultipleDocumentsInProgressDescription:
    'Die markierten ${numberOfDocuments}-Dokumente haben die Verarbeitung nicht abgeschlossen.',
  SingleDocumentInProgressDescription:
    '1 markiertes Dokument ist noch nicht abgeschlossen.',
  CancelBulkRedaction: 'Massenredigierung abbrechen',
  CancelBulkRedactionMessage: `You are about to stop the redaction process.
  Stopping redaction will cease redaction on current document and return you to the document index.`,
  StopRedaction: 'Redigierung stoppen',
  DocumentLocation: 'Dokumentenspeicherort',
  SecurityControls: 'Sicherheitskontrollen',
  SecuritySettings: 'Sicherheitseinstellungen',
  UseFolderSecurityFrom: 'Ordner-Sicherheitseinstellungen verwenden von',
  UseSecurityFromOpenedDocument:
    'Sicherheitseinstellungen aus dem geöffneten Dokument verwenden',
  UseSecurityFromOriginalDocument:
    'Sicherheitseinstellungen aus dem Originaldokument verwenden',
  UseSecurityFromOriginalFolder:
    'Sicherheitseinstellungen aus dem Originalordner verwenden',
  UseSecurityFromOriginalFoldersAndDocuments:
    'Verwenden Sie Sicherheitseinstellungen aus Originalordnern und Originaldokumenten',
  DocumentWillBeDisabledByDefault:
    'Das Dokument wird standardmäßig deaktiviert.',
  DocumentsAndFoldersWillBeDisabledByDefault:
    'Ordner und Dokumente werden standardmäßig deaktiviert.',
  ImportDataRoomError:
    'Der Import mit der Tracking-ID ${trackingId} ist ein Fehler. Bitte versuchen Sie es erneut.',
  RedactionError:
    '${fileName} konnte nicht redigiert werden, bitte versuchen Sie es erneut.',
  RedactionHowRedactionSavingWorks: 'Wie das Redigieren speichern',
  RedactionEducationDialogForAdministrators: 'Für Administratoren',
  RedactionEducationDialogForGuests: 'Für Gäste',
  RedactionEducationDialogPreviewDownload: 'Vorschau/Download',
  RedactionEducationDialogEditing: 'Bearbeiten',
  RedactionEducationDialog1Layer: '1-Ebenen-Dokument',
  RedactionEducationDialog2Layer: '2-Ebenen-Dokument',
  RedactionEducationDialogRedactionsAreBakedIn:
    'Redigierungen sind eingebrannt',
  RedactionEducationDialogRedactionsAreEditable:
    'Redigierungen können bearbeitet werden',
  RedactionSaveAsNewDocument: 'Als neues Dokument speichern',
  RedactionHowSavingWorks: 'So funktionieren das Speichern',
  ChangesYouMadedWillNotBeSaved:
    'Die von Ihnen vorgenommenen Änderungen werden nicht gespeichert.',
  IsRedacted: 'ist redigiert.',
  DocumentsAddedFrom: 'Dokumente hinzugefügt von ${dataroomName}.',
  GoToFile: 'Zeigen Sie mir das Dokument',
  GoToImportFolder: 'Zeigen Sie mir den Ordner',
  Thanks: 'Vielen Dank',
  Validation_DuplicatedDocumentInFolder:
    'Das Dokument ${documentName} ist bereits in ${folderName} vorhanden',
  Validation_NameCannotBeEmpty: 'Der Name darf nicht leer sein.',
  Continue: 'Weiter',
  RedactingMessage:
    'Die Redigierung kann eine Weile dauern. Bitte nicht aktualisieren',
  Name: 'Name',
  Number: 'Nummer',
  LearnMore: 'Erfahren Sie mehr',
  BulkActionsNoItemsWillBeAffected:
    'Von diesem Vorgang sind keine Elemente betroffen.',
  Saving: 'Speichern',
  YouCanKeepWorking: 'Sie können weiter arbeiten.',
  Copy: 'Kopieren',
  CopyDocument: 'Dokument kopieren nach',
  CopyFolder: 'Ordner kopieren nach',
  Import: 'Importieren',
  DataRooms: 'Datenräume',
  Accept: 'Akzeptieren',
  TermOfAccess: 'Zugangsdauer',
  TermOfAccessCheckbox:
    'Ich habe die Bedingungen gelesen, verstanden und akzeptiere sie',
  ImportingDataFrom: 'Hinzufügen von Dokumenten von ${dataroomName}.',
  Refresh: 'Aktualisieren',
  ImportTo: 'Importieren nach',
  ImportError: 'Importfehler, bitte wenden Sie sich an den Administrator.',
  Back: 'Zurück',
  LastAccessed: 'Zugriff',
  NeverAccessed: 'Keinen Zugriff',
  Remaining: 'verbleiben',
  SubmissionWindowIsOpen: 'Das Übermittlungsfenster ist geöffnet.',
  SubmissionWindowHasEnd:
    'Das Übermittlungsfenster ist beendet. Dokumente, die Sie jetzt hochladen, werden als verspätet markiert.',
  FromYourComputer: 'Von Ihrem Computer',
  FromAnotherDataRoom: 'Aus einem anderen Datenraum',
  FromFolderStructure: 'Aus Ordnerstruktur',
  FromDataRoom: 'Aus Datenraum',
  AddFromDataRoom: 'Aus Datenraum hinzufügen',
  AddFromFolderStructure: 'Aus Ordnerstruktur hinzufügen',
  ImportDialogDataRoomScreenDialogTitle: 'Dokumente aus Datenraum hinzufügen',
  ImportDialogDataRoomScreenHeading:
    'Wählen Sie den Datenraum, der die hinzuzufügenden Dokumente enthält.',
  ImportDialogTermOfAccessScreenDialogTitle:
    'Fügen Sie Dokumente von ${dataroomName} hinzu',
  ImportDialogTermOfAccessScreenHeading:
    'Sie müssen die Zugangsbedingungen akzeptieren, bevor Sie Dokumente aus diesem Datenraum hinzufügen können.',
  ImportDialogDataRoomScreenRadioBtn:
    'Dokumente aus diesem Datenraum hinzufügen',
  ImportDialogDocumentListScreenHeading:
    'Wählen Sie ein oder mehrere Dokumente aus, die zu Ihrem Datenraum hinzugefügt werden sollen.',
  ImportDialogEmptyDataRoom:
    'Es gibt keine Datenräume, auf die Sie zugreifen können.',
  ImportDialogEmptyDocument:
    'Es gibt keine Dokumente aus diesem Datenraum, die Sie hinzufügen können.',
  ImportDialogDocumentListScreenDialogTitle:
    'Fügen Sie Dokumente von ${dataroomName} hinzu',
  UserTypeCode_ADM: 'Administrator',
  UserTypeCode_DOP: 'Herausgeber',
  UserTypeCode_GUE: 'Gast',
  UserTypeCode_USQ: 'LimitedViewer',
  UserTypeCode_USR: 'Betrachter',
  QnaRoleCode_QVW: 'Fragen Betrachter',
  QnaRoleCode_BAP: 'Bieter-Approver',
  QnaRoleCode_BAA: 'Bieter-Autor',
  QnaRoleCode_BMC: 'Hauptkontakt des Bieters',
  QnaRoleCode_IAP: 'Interner Approver',
  QnaRoleCode_IAA: 'Sell-Side',
  QnaRoleCode_IMC: 'Interner Hauptkontakt',
  QnaRoleCode_IOB: 'Sell-Side',
  QnaRoleCode_QAU: 'Fragen stellen',
  QnaRoleCode_QAP: 'Fragen-Approver',
  QnaRoleCode_ADR: 'Antworten entwerfen',
  QnaRoleCode_AAU: 'Antwortverfasser',
  QnaRoleCode_AAP: 'Antworten freigeben',
  QnaRoleCode_QAA: 'Q&A-Administrator',
  QnaRoleCode_QAO: 'Q&A-Beobachter Vollkontrolle',
  QnaRoleCode_QOV: 'Nur Q&A-Beobachteransicht',
  DemoRoom: '*DEMO* - ${dataroomName}',
  SearchDocuments_InputPlaceholder:
    'Geben Sie ein Schlüsselwort oder den Namen und die Nummer eines Dokuments oder Ordners ein',
  SearchDocuments_Find: 'Finden',
  SearchDocuments_Results: 'Ergebnisse',
  SearchDocuments_FullTextSearchSummary:
    '${totalItems} Dokument${plural} stimmt mit dem Inhalt überein',
  SearchDocuments_DocumentSummary:
    '${totalItems}-Dokument ${plural} stimmt mit Titel, Nummer und Code überein',
  SearchDocuments_FolderSummary:
    '${totalItems}-Ordner ${plural} stimmt mit Titel, Nummer und Code überein',
  New: 'NEU',
  Browse: 'Durchsuchen',
  ImportFolder_GlobalActionButton: 'Ordnerstruktur importieren',
  ImportFolder_Title: 'Importieren Sie Ihre Ordnerstruktur',
  ImportFolder_Step1_DragDropDescription1:
    'Ziehen Sie per Drag &amp; Drop oder durchsuchen Sie eine Excel-Datei, um Ordner zu importieren.',
  ImportFolder_Step1_DragDropDescription2:
    'Hinweis: Ordner werden beim Import deaktiviert.',
  ImportFolder_Step1_DragDropDescription3:
    'Formatieren Sie Ihre Excel-Datei mit der Ordnernummer als Spalte A und dem Ordnernamen als Spalte B oder einfach mit {0}',
  ImportFolder_Step1_FileUploaded: '{0} hochgeladen',
  ImportFolder_Step1_DownloadTemplateFile: 'Excel-Vorlage herunterladen',
  ImportFolder_Step1_Heading: 'Sie importieren die Ordnerstruktur in {0}',
  ImportFolder_Step1_ErrorMessage:
    'Ihre Datei wurde nicht hochgeladen. Versuchen Sie es erneut mit einer .xls- oder .xlsx-Datei.',
  ImportFolder_Step2_Title: 'Überprüfen und schließen Sie Ihren Import ab',
  ImportFolder_Step2_SuccessMessage: 'Ihre Ordner wurden importiert.',
  Document_Preview: 'Dokumentenvorschau',
  FileUnsupportedForPreview: `Wir können Ihnen keine Vorschau dieser Datei anzeigen.
    Sie müssen die Datei herunterladen, um den Inhalt anzuzeigen.`,
  ErrorWhileDownloadingFile:
    'Beim Versuch des Downloads ist ein Fehler aufgetreten. Bitte wenden Sie sich mit ${ErrorCode} an unseren Kundenservice',
  CannotDownloadingFile: 'Datei kann nicht heruntergeladen werden. ',
  ClickToSeeDetails: 'Klicken Sie, um Details anzuzeigen',
  TryAgain: 'Versuchen Sie es erneut',
  NumberingUpdatedFor: 'Nummerierung aktualisiert für',
  Items: 'Gegenstände',
  YoureAboutToChangeTheNumberingOn:
    'Sie sind im Begriff, die Nummerierung zu ändern',
  ThisMayHaveAnImpactOnPeopleReferencingTheDocumentOnThisProject:
    'Dies kann Auswirkungen auf Personen haben, die auf das Dokument in diesem Projekt verweisen.',
  AllDocuments: 'Alle Dokumente',
  AllQnaAndAttachments: 'Alle Fragen und Antworten und Anhänge',
  AllSubmissionDocuments: 'Sämtliche Einreichungsunterlagen',
  AllEvaluationAttachments: 'Alle Evaluierungsanhänge',
  AllUserActivityDocumentViewsReports:
    'Berichte zu allen Aktivitätsprotokollen nach Personen- und Dokumentansichten',
  IncludeDocuments: 'Dokumente einschließen',
  IncludeSubmissionDocuments: 'Einreichungsdokumente einschließen',
  IncludeEvaluationAttachments: 'Evaluierungsanhänge einschließen',
  IncludeQna: 'Fragen und Antworten einschließen',
  IncludeQnaAttachments: 'Fragen und Antworten als Anhänge einschließen',
  IncludeDisabledDocuments: 'Deaktivierte Dokumente einschließen',
  Documents: 'Dokumente',
  SubmissionDocuments: 'Einreichungsunterlagen',
  EvaluationAttachments: 'Evaluierungsanhänge',
  QnaAttachments: 'Fragen und Antworten als Anhänge',
  DisabledDocuments: 'Deaktivierte Dokumente',
  DocumentsVisibleTo: 'Dokumente sichtbar für',
  SubmissionDocumentsVisibleTo: 'Einreichungsdokumente sichtbar für',
  QnaAndAttachmentsVisibleTo: 'Fragen und Antworten und Anhänge sichtbar für',
  QnaAttachmentsVisibleTo: 'Q&A-Anhänge sichtbar für',
  QnaVisibleTo: 'Fragen und Antworten sichtbar für',
  IncludeDisabledDocumentsWarningMessage:
    'Durch das Einschließen deaktivierter Dokumente werden Dokumente angezeigt, die für das ausgewählte Team derzeit nicht sichtbar sind. Diese Option wird nicht empfohlen.',
  AllSubTeams: 'Alle Unterteams',
  AllSecurityGroups: 'Alle Sicherheitsgruppen',
  NoSubTeams: 'Keine Unterteams',
  AdminOnlyFullArchive: 'Nur für Administratoren – vollständiges Archiv',
  Team: 'Team',
  SubTeam: 'Untergruppe',
  ArchiveName: 'Archivname',
  Options: 'Optionen',
  Summary: 'Zusammenfassung',
  CreateArchive: 'Archiv erstellen',
  IncludeInArchive: 'In Archiv einschließen',
  VisibleTo: 'Sichtbar für',
  SubmissionDocuments_LowerCase: 'Einreichungsunterlagen',
  EvaluationAttachments_LowerCase: 'Evaluierungsanhänge',
  Qna: 'Fragen und Antworten',
  QnaAndAttachments_LowerCase: 'Fragen und Antworten als Anhänge',
  DisableDocuments_LowerCase: 'deaktivierte Dokumente',
  Questions_LowerCase: 'Fragen',
  Attachments_LowerCase: 'Anhänge',
  DocumentViewsReports_LowerCase: 'Berichte zu Dokumentansichten',
  ActivityLogsByPerson_LowerCase: 'Aktivitätsprotokolle nach Person',
  InProgress: 'In Bearbeitung',
  Expired: 'Abgelaufen',
  Failed: 'Fehlgeschlagen',
  YourArchiveIsBeingGenerated: 'Ihr Archiv wird generiert...',
  YourArchiveHasBeenQueued: 'Ihr Archiv wurde in die Warteschlange gestellt.',
  AnEmailWillBeSentTo: 'Eine E-Mail wird an gesendet',
  WithADownloadLinkWhenTheArchiveIsReady:
    'mit einem Download-Link, wenn das Archiv fertig ist.',
  ContactSupport: 'Wenden Sie sich an den Support',
  SomethingWentWrong: 'Etwas ist schief gelaufen.',
  WeAreUnableToProcessYourArchiveRequest:
    'Wir können Ihre Archivierungsanfrage nicht bearbeiten.',
  Retrieving: 'Aufrufen',
  FullArchiveAdminOnly: 'Vollständiges Archiv - nur Administrator',
  Filtered: 'Gefiltert',
  CreateYourFirstArchive: 'Erstellen Sie Ihr erstes Archiv.',
  AutoTruncateHelpText:
    'Wir wenden die bestmögliche Kürzung an, um sicherzustellen, dass die Dateipfade nicht mehr als 260 Zeichen lang sind.',
  Becomes_LowerCase: 'wird',
  TruncationType: 'Kürzungstyp',
  AutoTruncate: 'Automatisch abschneiden',
  DoNotTruncate: 'Nicht abschneiden',
  KeepLastSegmentOfNumbers: 'Letztes Nummernsegment behalten',
  KeepNumbersOnly: 'Nur Nummern behalten',
  KeepNamesOnly: 'Nur Namen behalten',
  FullArchiveHelpText:
    'Datenraum-Administratoren können alle Dokumente und Fragen-Anhänge anzeigen.',
  ArchiveHelpText:
    'Wir werden ${includedOptions} einschließen, die für ${teamOrSubTeamName} sichtbar sind.',
  HowArchivesWork: 'Wie Dokumente funktionieren',
  ArchivesContainTheFullFilePathForEveryArchivedDocument:
    'Archiv enthält den vollständigen Dateipfad für jedes archivierte Dokument.',
  FilePathsAreLimitedTo260Characters:
    'Die Dateipfade sind auf 260 Zeichen begrenzt.',
  YouMayNeedToTruncateTheFilePaths:
    'Möglicherweise müssen Sie die Dateipfade kürzen, damit Sie sie auf Ihrem Computer anzeigen können.',
  YouCanUseAZipApplicationToViewArchivesWithLongFilePaths:
    'Alternativ können Sie eine ZIP-Anwendung verwenden, um Archiv mit langen Dateipfaden anzuzeigen.',
  YourArchiveIsDownloading: 'Ihr Archiv wird heruntergeladen',
  DoNotTruncateHelpText:
    'Sie können eine ZIP-Anwendung verwenden, um Dokumente mit langen Dateipfaden zu extrahieren.',
  Share: 'Teilen',
  SecureShare_Capitalize: 'Sichere Freigabe',
  SecureShare_SentenceCase: 'Sichere Freigabe',
  ValidateEmailToView: 'Bestätigen Sie die E-Mail-Adresse, um sie anzuzeigen',
  ValidateEmailToViewDescription:
    'Personen müssen ihre E-Mail-Adresse bestätigen, bevor sie das Dokument anzeigen.',
  EnterPasscodeToView: 'Geben Sie zum Anzeigen den Sicherheitscode ein',
  EnterPasscodeToViewDescription:
    'Legen Sie einen Sicherheitscode fest, den Personen eingeben müssen, bevor sie das Dokument anzeigen können.',
  AnyoneWithALinkCanView: 'Jeder mit einem Link kann anzeigen',
  AnyoneWithALinkCanViewDescription:
    'Personen mit dem Link haben ungeschützten Zugriff auf das Dokument.',
  NoAccess: 'Kein Zugriff',
  NoAccessDescription:
    'Personen mit freigegebenen Links können das Dokument nicht mehr anzeigen.',
  SecureShareLinkSettings:
    'Kontrollieren Sie den Zugriff auf Ihren geteilten Link',
  Watermark: 'Wasserzeichen',
  LinkExpiresIn: 'Der Link läuft in ${duration} ab (${timezone})',
  LinkExpiredDuration: 'Der Link ist vor ${duration} abgelaufen (${timezone})',
  LinkExpirationDate:
    'Legen Sie ein Datum und eine Uhrzeit fest, bis der Link abläuft',
  On: 'Ein',
  Off: 'Aus',
  CreateWatermark: 'Wasserzeichen erstellen',
  None: 'Keine',
  YouAreReadyToShare: 'Sie sind bereit zum Teilen',
  WeHaveCopiedTheSecureShareLinkToYourClipboard:
    'Wir haben den sicheren Link für <strong data-ansarada-ccd="true">${fileName}</strong> in Ihre Zwischenablage kopiert.',
  AnyoneWithTheLinkCanviewTheDocument:
    'Jeder mit dem Link kann das Dokument anzeigen.',
  PeopleNeedToValidateTheirEmailToViewTheDocument:
    'Personen müssen ihre E-Mail-Adresse bestätigen, um das Dokument anzuzeigen.',
  PeopleNeedToEnterThePasscodeToViewTheDocument:
    'Personen müssen den Sicherheitscode ( <strong data-ansarada-ccd="true">${passCode}</strong> ) eingeben, um das Dokument anzuzeigen.',
  SecureShareLink: 'Link zum sicheren Teilen',
  SecureShareLinkCopy: 'Sicherer Link zum Kopieren und Teilen',
  SaveAndRemoveAccess_SentenceCase: 'Zugriff speichern und entfernen',
  AccessPasscode:
    'Geben Sie einen Sicherheitscode ein, um auf den Link zugreifen zu können',
  SettingsSaved: 'Einstellungen gespeichert',
  WeHaveExpiredAllSecureShareLinks:
    'Wir haben alle sicheren Freigabe-Links für <strong data-ansarada-ccd="true">${fileName} abgelaufen</strong> .',
  LinkShareWithCode: 'Linkoffenlegung mit Code',
  LinkShareWithEmail: 'Link teilen mit E-Mail',
  LinkShare: 'Link teilen',
  AllDownloadedCopiesWillSelfDestruct:
    'Alle heruntergeladenen Kopien werden selbst zerstört.',
  NeedHelpSharingALinkOrDocument:
    'Benötigen Sie Hilfe beim Teilen eines Links oder Dokuments?',
  HowDoIExpireAllLinksToADocument:
    'Wie kann ich alle Links zu einem Dokument ablaufen?',
  WhatDoIDoToDenyADownload:
    'Was kann ich tun, um einen Download zu verweigern?',
  FindOutMoreAboutSecureShare:
    'Erfahren Sie mehr über die sichere Freigabe von Dokumenten',
  SaveAndCopyLink_SentenceCase: 'Link speichern und kopieren',
  ShareDocumentSecurely_SentenceCase: 'Dokument sicher teilen',
  ShareDocumentEmptyStateDescription:
    'Wählen Sie ein Dokument aus der Spalte „Dokumente verwalten“ aus, um mit der Freigabe zu beginnen.',
  FirstTellUsWhoYouAre: 'Sagen Sie uns zunächst, wer Sie sind',
  ToAccessTheSharedDocumentWeNeedToVerifyYourEmailAddress:
    'Um auf das freigegebene Dokument zugreifen zu können, müssen wir Ihre E-Mail-Adresse bestätigen.',
  WeWillSendYouAnEmailSoYouCanAccessTheSharedDocument:
    'Wir senden Ihnen eine E-Mail, damit Sie auf das freigegebene Dokument zugreifen können.',
  EnterAnEmailAddress: 'Geben Sie eine E-Mail-Adresse ein',
  EnterAValidEmailAddress: 'Geben Sie eine gültige E-Mail-Adresse ein',
  EmailIsRequired: 'E-Mail ist erforderlich',
  VerifyMyEmail_SentenceCase: 'Meine E-Mail-Adresse bestätigen',
  FirstEnterThePasscode: 'Geben Sie zunächst den Passwort ein',
  ToAccessTheSharedDocumentYouNeedToEnterThePasscode:
    'Um auf das freigegebene Dokument zugreifen zu können, müssen Sie den Sicherheitscode eingeben.',
  ReachOutToThePersonWhoSharedDocumentYouNeedToEnterThePasscode:
    'Wenden Sie sich an die Person, die den Link mit Ihnen geteilt hat, um mehr zu erfahren.',
  EnterTheAccessPasscode: 'Geben Sie den Zugangscode ein',
  ViewDocument_SentenceCase: 'Dokument anzeigen',
  TheDocumentIsNoLongerAvailable: 'Das Dokument ist nicht mehr verfügbar',
  YourAccessMayHaveBeenRemovedOrTheDocumentDeleted:
    'Möglicherweise wurde Ihr Zugriff entfernt oder das Dokument gelöscht.',
  ReachOutToThePersonWhoSharedTheLinkWithYouToFindOutMore:
    'Wenden Sie sich an die Person, die den Link mit Ihnen geteilt hat, um mehr zu erfahren.',
  SecurityControlsOn: 'Sicherheitskontrollen aktiviert',
  SecurityControlsOff: 'Sicherheitskontrollen deaktiviert',
  CopyingAllowed: 'Kopieren erlaubt',
  CopyingDenied: 'Kopieren verweigert',
  EditingAllowed: 'Bearbeiten erlaubt',
  EditingDenied: 'Bearbeitung verweigert',
  DenyCopyingDisabled: 'Kopierverbot deaktiviert',
  DenyEditingDisabled: 'Bearbeitung verweigern deaktiviert',
  DenyPrintingDisabled: 'Drucken verweigern deaktiviert',
  DenySavingDisabled: 'Speichern verweigern deaktiviert',
  Redirecting: 'Umleiten...',
  CheckYourInbox: 'Öffnen Sie in Ihrem Posteingang',
  YouAreOnADifferentDevice: 'Sie verwenden ein anderes Gerät',
  YouCanOnlyViewThisDocumentFromTheSameDeviceUsedToVerifyYourEmail:
    'Sie können dieses Dokument nur auf demselben Gerät anzeigen, das zum Bestätigen Ihrer E-Mail-Adresse verwendet wurde.',
  WeHaveSentAnEmailToYourEmail: 'Wir haben eine E-Mail an gesendet ',
  WithTheAccessToViewTheDocument:
    ' mit dem Zugriff, um das Dokument anzuzeigen.',
  ViewActivity: 'Aktivität anzeigen',
  PasscodeIsNotCorrect: 'Der Code ist nicht korrekt',
  SubmissionDocumentUploaded: '1 Dokument zur Einreichung hochgeladen.',
  SubmissionDocumentsUploaded:
    '${NumberOfDocuments}-Dokumente wurden in die Übermittlung hochgeladen.',
  HowSubmissionsWork: 'Wie Einreichungen funktionieren',
  AllAddedDocumentsAreAutomaticallySubmitted:
    'Alle hinzugefügten Dokumente werden automatisch eingereicht.',
  YouHaveUntilTheCloseOfTheSubmissionWindowToMakeChanges:
    'Sie haben bis zum Schließen des Übermittlungsfensters Zeit, um Änderungen vorzunehmen.',
  UntilClose: 'bis nahe',
  Ansarada: 'Ansarada',
  BulkEditFileUpload: `oder ziehen Sie Ihr verfeinertes Excel per Drag &amp; Drop hier. Wir'
  overview of the edits.`,
  BulkEditFileUploadAfterUploading:
    'oder ziehen Sie die richtige Datei per Drag &amp; Drop hier, um nahtlos zu wechseln.',
  BulkEditExcelReady:
    'Auf Punkt, ${name}! Haben Sie Ihr bearbeitetes Excel fertig?',
  BeforeYourEdits: 'Vor Ihren Bearbeitungen',
  AfterYourEdits: 'Nach Ihren Bearbeitungen',
  DropFilesHereToAttach: 'Legen Sie die Dateien hier zum Anhängen ab',
  KickOffBy: 'Anstoß durch',
  DownloadingTheExcelVersion: 'Download der Excel-Version',
  OfYourDocumentIndex: 'Ihres Dokumentindex.',
  BulkEditNextButtonGuide:
    'Tippen Sie nach der Feinabstimmung auf die Schaltfläche &#39; <strong>Weiter</strong> &#39;, um die Informationen hochzuladen und die Effizienz in Aktion zu erleben.',
  BulkEditDownloadExcelFileHeading:
    'Verbessern Sie Ihren Workflow: Nahtloses Bearbeiten von Dokumenten.',
  BulkEditAllSetHeading: 'Alle gesetzt, ${name}! Sie sind zum Handeln bereit.',
  BulkEditButtonGuide:
    'Sobald Sie auf die Schaltfläche Massenbearbeitung klicken, können wir $ <strong>{combinedText}</strong> gemäß Ihren Anweisungen anpassen.',
  HeadsUpThough: `<strong>Nur als Hinweis:</strong> Wir werden nicht mindestens eine Bearbeitung anwenden. Die Administratoren haben sie aus dem Dokumentindex entfernt.`,
  ProTip: 'Ein Profi-Tipp?',
  ProTipDescription:
    'Erwägen Sie, die neueste Excel-Version Ihres Dokumentindex herunterzuladen. Sie erhalten einen makellosen Schnappschuss, bevor die Bearbeitungen wirksam werden.',
  GrabItHere: 'Schnappen Sie es sich hier.',
  BulkEditSuccessMessage: `Ihre Massenaktualisierung wird angewendet und jetzt im Dokumentindex. Wir sind für Sie da!`,
  NotTheRightExcel: 'Nicht das richtige Excel?',
  UploadFailedMessage:
    'Hochladen fehlgeschlagen, ${name}. Beim Hochladen ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.',
  FailedMessage:
    'Aktualisierung fehlgeschlagen, ${name}. Beim Massenupdate ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.',
  DoNotHaveAccessMessage:
    'Sie haben keinen Zugriff auf einige der geänderten Dokumente und Ordner im bereitgestellten Excel. Bitte fragen Sie den Datenraum-Administrator, um den Vorgang durchzuführen',
};
